
export const ALL = 'ALL';
export const ALL_PRODUCT_LOADING = 'ALL_PRODUCT_LOADING';
export const ALL_ERROR = 'ALL_ERROR';


export const MEN = 'MEN';
export const MEN_CATEGORY_LOADING= 'MEN_CATEGORY_LOADING';
export const MEN_CATEGORY_ERROR = 'MEN_CATEGORY_ERROR';


export const WOMEN = 'WOMEN';
export const WOMEN_CATEGORY_LOADING= 'WOMEN_CATEGORY_LOADING';
export const WOMEN_CATEGORY_ERROR = 'WOMEN_CATEGORY_ERROR';

export const ELECTRONICS = 'ELECTRONICS';
export const ELECTRONICS_CATEGORY_LOADING= 'ELECTRONICS_CATEGORY_LOADING';
export const ELECTRONICS_CATEGORY_ERROR = 'ELECTRONICS_CATEGORY_ERROR';

export const PRODUCT_DETAILS = 'PRODUCT_DETAILS';
export const PRODUCT_DETAILS_CATEGORY_LOADING= 'PRODUCT_DETAILS_CATEGORY_LOADING';
export const PRODUCT_DETAILS_CATEGORY_ERROR = 'PRODUCT_DETAILS_CATEGORY_ERROR';


export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';

export const INCREASE_QUANTITY = 'INCREASE_QUANTITY';
export const DECREASE_QUANTITY = 'DECREASE_QUANTITY';



export const  USER_SIGNUP_FAIL = 'USER_SIGNUP_FAIL';
export const  USER_SIGNUP_REQUEST = 'USER_SIGNUP_REQUEST';
export const  USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';

export const  USER_SIGNIN_FAIL = 'USER_SIGNIN_FAIL';
export const  USER_SIGNIN_REQUEST = 'USER_SIGNIN_REQUEST';
export const  USER_SIGNIN_SUCCESS = 'USER_SIGNIN_SUCCESS';
export const  USER_SIGNOUT = 'USER_SIGNOUT';

export const  USER_DETAIL_REQUEST = 'USER_DETAIL_REQUEST';
export const  USER_DETAIL = 'USER_DETAIL';
export const  USER_DETAIL_ERROR = 'USER_DETAIL_ERROR';

export const  SAVE_SHIPPING_ADDRESS = 'SAVE_SHIPPING_ADDRESS';